import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';

interface Props {
  avail_id: number;
  availability: string;
  bottomMargin?: boolean;
  justify?: string;
}

function StockInfo({
  avail_id,
  availability,
  bottomMargin = false,
  justify = 'initial',
}: Props) {
  const isAvailable = avail_id === 1;
  const availabilityText = !availability ? 'Nedostupné' : availability;
  return (
    <StockCount
      justify={justify}
      bottomMargin={bottomMargin}
      available={isAvailable}
    >
      {availabilityText}{' '}
    </StockCount>
  );
}

const StockCount = styled.span<{
  available: boolean;
  bottomMargin: boolean;
  justify: string;
}>`
  display: flex;
  align-items: center;
  font-size: ${rem(16)};
  color: ${({ theme, available }) =>
    available ? theme.colors.stockCountAvailable : theme.colors.stockCountSold};
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(22)};
  width: 100%;
  text-align: left;
  justify-content: ${({ justify }) => justify};
  margin-bottom: ${({ bottomMargin }) => (bottomMargin ? rem(11) : 0)};
`;

export { StockInfo };
